<script>
  export let icon;
  export let onClick;
</script>

<div class="roundedButtonContainer" on:click={onClick}>
  <img src={icon} alt="Option Icon" />
</div>

<style>
  div.roundedButtonContainer {
    width: 38px;
    height: 38px;
    background-color: var(--labit-background-gray);
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 11px;
  }

  img {
    width: 50%;
  }

  /* Animations */

  div.roundedButtonContainer {
    transition: opacity 0.5s linear 0s;
  }

  div.roundedButtonContainer:hover {
    opacity: 0.5;
  }
</style>
